module.exports = __webpack_public_path__ + "img/10.e704fdb7.jpg";